export default __webpack_public_path__ + "static/media/1-color.eec7b302.svg";